import $ from 'jquery';

function initMobileDrilldown() {
    const $drilldown = $('#offCanvas .drilldown');

    if (!$drilldown.length || typeof window.Foundation === 'undefined' || !window.Foundation.Drilldown) {
        return;
    }

    const existing = $drilldown.data('zfPlugin');

    if (existing && typeof existing.destroy === 'function') {
        existing.destroy();
    }

    new window.Foundation.Drilldown($drilldown, {
        parentLink: true,
        closeOnClick: true,
        autoHeight: true,
        animateHeight: true,
    });

    $drilldown.css({
        height: 'auto',
        minHeight: 0,
        backgroundColor: 'transparent',
    });
}

export function initMobileMenu() {
    const offCanvas = document.getElementById('offCanvas');

    if (!offCanvas) {
        return;
    }

    $(offCanvas).on('opened.zf.offcanvas', initMobileDrilldown);
}
